import { render, staticRenderFns } from "./JobBoardLogs.vue?vue&type=template&id=2113a883&"
import script from "./JobBoardLogs.vue?vue&type=script&lang=js&"
export * from "./JobBoardLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports